import { VerticalTabWorkList } from "../../secondary/VerticalTabWorkList";
import style from "./workListCommon.module.scss";
import { useWorkListTabs } from "./hooks/useWorkListTabs";
import { WorklistScreen } from "./worklistScreen";
import { WORKLIST_CONFIG } from "./worklistConfig";

export function CompletedAssessment({ facilityNumber }) {
  const { dispatch, reviewLockedAssessments } = useWorkListTabs(facilityNumber, "completeAssessmentsValues");

  const tabList = [
    {
      name: `Reviewed & Locked, Assessment can't be changed ${reviewLockedAssessments}`,
      key: "reviewedLocked",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.reviewLockedAssessment} />,
      bottomName: "Reviewed & Locked",
      bgcolor: style.completed_bgcolor,
    },
  ];
  return <VerticalTabWorkList tabList={tabList} dispatch={dispatch} />;
}
